import { STANDARD_BREAKOUT_TEMPLATE_ID } from '../../utils/breakoutProtocol';

/** Owns the setup form independently of panel visibility and shared room state. */
export class BreakoutDraftOwner {
  count = 3;
  names = ['Room 1', 'Room 2', 'Room 3'];
  mode = 'assign';
  minutes = 0;
  templateIds = Array.from({ length: 3 }, () => STANDARD_BREAKOUT_TEMPLATE_ID);
  assignments: Record<string, string> = {};

  resize(count: number, defaultTemplateId: string): void {
    this.count = count;
    this.names = Array.from(
      { length: count },
      (_, index) => this.names[index] ?? `Room ${index + 1}`,
    );
    this.templateIds = Array.from(
      { length: count },
      (_, index) => this.templateIds[index] ?? defaultTemplateId,
    );
  }

  applyCatalog(validIds: ReadonlySet<string>, defaultTemplateId: string): void {
    this.templateIds = this.templateIds.map((id) =>
      !validIds.has(id) || id === STANDARD_BREAKOUT_TEMPLATE_ID ? defaultTemplateId : id,
    );
  }

  reset(): void {
    this.count = 3;
    this.names = ['Room 1', 'Room 2', 'Room 3'];
    this.mode = 'assign';
    this.minutes = 0;
    this.templateIds = Array.from({ length: 3 }, () => STANDARD_BREAKOUT_TEMPLATE_ID);
    this.assignments = {};
  }
}
